import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { usePlay } from "@/modules/play/context/playContext";

import { useGameId } from "./hooks/useGameId";

export { PersonalizationLayout };

function PersonalizationLayout() {
  const gameId = useGameId();
  const { readProfile } = usePlay();

  useEffect(() => {
    if (gameId) {
      readProfile();
    }
  }, [gameId, readProfile]);

  return <Outlet />;
}
